module.exports = __webpack_public_path__ + "static/media/pdf_black.e7c6c21b.svg";